
import Vue from 'vue'
export default Vue.extend({
   name: 'BaseButton',
   props: {
      label: { default: '', type: String },
      actionLabel: { default: '', type: String },
      showIcon: { default: false, type: Boolean },
      icon: { default: '', type: String },
      type: { default: '', type: String },
      size: { default: '', type: String },
      block: { default: '', type: String },
      enabled: { default: true, type: Boolean },
      processing: { default: false, type: Boolean },
   },
   computed: {
      currentLabel(): string {
         return this.processing ? this.actionLabel : this.label
      },
   },
   methods: {
      onClick() {
         if (this.enabled && !this.processing) {
            this.$emit('click')
         }
      },
   },
})
